module.exports = __webpack_public_path__ + "static/media/semiconductors_hero_desktop.5960ec84.jpg";